import { TableCell, TableRow } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';
import {
  format1Decimal,
  format2Decimal,
  formatComma,
  formatMoney,
  openNOC,
} from '../../utils';

const MobileViewRowCells = ({ styles, row, index, setStateAction }) => {
  return (
    <TableRow
      key={index}
      style={
        index % 2
          ? { background: '#e5e5e5', height: '25px' }
          : { background: 'white', height: '25px' }
      }
    >
      <TableCell
        style={{ color: 'red', padding: '0px', fontWeight: 'bold' }}
        width="10px"
      >
        {row.div}
      </TableCell>
      <TableCell style={styles.rowCell} width="14%" align="left">
        <Link
          onClick={() => openNOC(row.Symbol)}
          style={{ color: 'blue' }}
          to="/stocks"
          // target="_blank"
        >
          {row.Symbol}
        </Link>
      </TableCell>
      <TableCell style={styles.rowCell} width="16%" align="right">
        ${formatMoney(row.spot)}
      </TableCell>
      <TableCell style={styles.rowCellEdge} width="15%" align="right">
        <span style={row.spotchg > 0 ? { color: 'green' } : { color: 'red' }}>
          {format2Decimal(row.spotchg)}
        </span>
      </TableCell>
      <TableCell style={styles.rowCell} width="16%" align="right">
        <strong>{format1Decimal(row.RV)}</strong>
      </TableCell>

      <TableCell
        style={{ ...styles.rowCell, textAlign: 'end' }}
        width="16%"
        align="right"
      >
        <Link
          onClick={async () => {
            setStateAction({
              isVolClicked: true,
              modalRowData: row,
            });
          }}
          style={{ ...styles.removeUnderline, padding: '5px' }}
        >
          {' '}
          {formatComma(row.volume)}{' '}
        </Link>
      </TableCell>
      <TableCell
        style={{
          ...styles.rowCell,
          width: '16%',
          borderRight: 'none',
        }}
        align="right"
      >
        <span style={row.atmchg > 0 ? { color: 'green' } : { color: 'red' }}>
          {row.atmchg > 0
            ? '+' + format1Decimal(row.atmchg * 100)
            : format1Decimal(row.atmchg * 100)}
        </span>
      </TableCell>
    </TableRow>
  );
};

export default MobileViewRowCells;



// WEBPACK FOOTER //
// ./src/Pages/UnusualOptionsActivity/components/tables/mobileViewRowCells.jsx